import { observable, action, computed, runInAction, toJS } from 'mobx';

import service, { _service_without_hook } from '@service/index';
import fetchUrl from '@service/fetchUrl';
import { server_address } from '@src/env-config';

import global_store from '@store/Common/GlobalStore';

const localStorage_user_info_key = 'user_info';
class LoginUserStore {
  constructor() {
    let user_info_str = localStorage.getItem(localStorage_user_info_key);
    if(user_info_str !== null) {
      let user_info = JSON.parse(user_info_str);
      this.initUserData(user_info);
    }
  }

  /**
   * 初始化管理员信息
   * @param {*} user_info
   */
  @action
  initUserData(user_info) {
    for(let attr in user_info) {
      this[attr] = user_info[attr];
    }
  }

  /**
   * 是否是一级代理
   */
  @computed
  get isFirstLevel() {
    return this.superior_level == 1 && this.is_proxy == 1;
  }

  @action
  destroyUserData() {
    let attr_arr = [
      'balance',
      'is_proxy',
      'nick_name',
      'pet_name',
      'real_name',
      'superior_level',
      'time',
      'token',
      'id',
      'proxy_user',
      'radio',
      'tailor_user'
    ];
    attr_arr.map((item, index) => {
      this[item] = undefined;
    });
    service.clearHookQueue();
  }

  /**
   * 管理员是否已登录
   */
  @computed
  get is_login() {
    return !!this.token;
  }

  /**
   * 余额 balance
   */
  @observable
  balance;

  /**
   *  代理 is_proxy
   */
  @observable
  is_Proxy

  /**
   * 管理员 token
   */
  @observable
  token;

  /**
   * 用户名
   */
  @observable
  nick_name;

  /**
   * 昵称
   */
  @observable
  pet_name;

  /**
   * 上级代理
   */
  @observable
  proxy_user;

  /**
   * 返佣
   */
  @observable
  radio;

  @computed
  get rate() {
    let result;
    if( isNaN(this.radio * 100) ) {
      result = 0.00;
    } else {
      result = (Number(toJS(this.radio))).mul(100).toFixed(2);
    }
    return result;
  }

  /**
   * 头像
   */
  @observable
  tailor_user;
  @computed
  get tailor_user_url(){
    if (this.tailor_user === '')
    {
      return ''
    }
    else
    {
      return `${this.tailor_user}`;
      // return `${server_address}${this.tailor_user}`;
    }
  }

  /**
   * 真实姓名
   */
  @observable
  real_name;

  /**
   * 人员层级
   */
  @observable
  superior_level;

  /**
   * time
   */
  @observable
  time;

  /**
   * token
   */
  @observable
  token;

  /**
   * 用户id
   */
  @observable
  id;

  /**
   * 登录
   */
  login = async ({
    uname,
    pwd
  }) => {
    let url = fetchUrl.admin.login;
    let res = await service.fetchData({
      path: url,
      params : {
        uname,
        pwd
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        if (res.success)
        {
          localStorage.setItem(localStorage_user_info_key, JSON.stringify(res.data));

        }
      }
    });
    return res;
  }

  /**
   * 获取用户个人信息
   */
  fetchUserInfo = async() => {
    if(!this.is_login) { // 没登录
      return;
    }
    let url = fetchUrl.admin.fetch_balance;
    let res = await _service_without_hook.fetchData({
      path: url,
    });
    if(res.success) {
      runInAction(() => {
        this.balance = res.data.balance;
        this.radio = res.data.radio;
        this.proxy_user = res.data.proxy_user;
      });
    }
    return res;
  }

  /**
   * 测试调用方法  /proxy/index
   */
  testIndexFuction = async() => {
    let url = fetchUrl.admin.testIndex;
    let res = await service.fetchData({
      path:url
    });
  }

  /**
   * 退出登录
   */
  logout() {
    localStorage.removeItem(localStorage_user_info_key);
    this.destroyUserData();
  }
}

let login_user_store = new LoginUserStore();

export default login_user_store;



// WEBPACK FOOTER //
// ./src/Store/LoginUser/LoginUserStore.js